export enum TableItemTypeENUM {
  default = "default",
  action = "action",
}
